<template>
  <aside :class="{chat: true, chatOpen}">
    <header class="chatHeader">
      <h4 class="chatTitle">BUSCAR CLIENTE</h4>
      <div class="chatSearch">
        <b-input size="sm" placeholder="Buscar..." @input="handleSearchInput"/>
        <i class="fa fa-search" />
      </div>
    </header>

    <!--START POPUP VISTA DE VIDEO -->
    <vs-popup  v-bind:title="this.split_text_video" :active.sync="popupActive">
        <Widget
            bodyClass="p-0 mt"
            customHeader>

          <Media
              :kind="'video'"
              :isMuted="(false)"
              :src="this.split_src_video"
              :poster="this.split_poster_video"
              :autoplay="false"
              :controls="true"
              :loop="false"
              :ref="'fish'"
              :style="{width: '550px'}"                
              >
          </Media>

          <h4  class="fw-semi-bold ml-lg mb-lg">Puntuación {{this.split_points_video}}</h4>
            <div class="d-flex border-top">
              <div class="w-50 border-right p-3 px-4">
                <div class="d-flex justify-content-between align-items-center"><h6>17</h6>
                  <i class="la la-arrow-right text-success rotate-315" />
                </div>
                <p class="text-muted mb-0 mr">
                  <small>Reproducciones</small>
                </p>
              </div>
              <div class="w-50 p-3 px-4">
                <div class="d-flex justify-content-between align-items-center"><h6>{{this.split_percent_video}}</h6>
                  <i class="la la-arrow-right text-success rotate-315" />
                </div>
                <p class="text-muted mb-0 mr">
                  <small>Visto por usuarios</small>
                </p>
              </div>
            </div>
            <Widget
                title="<h5>Comentarios de la visita</h5>"
                collapse customHeader>
                <div>
                  <div class="mb text-center" data-percent="47" />
                  <p class="fs-mini text-muted">{{this.split_comments_video}}</p>
                </div>
            </Widget>
          </Widget>
        </vs-popup>
       <!--END POPUP VISTA DE VIDEO -->

    <div :class="{'chatPanel chatContacts': true, chatMessageOpen: chatMessageOpened}">
      
      <b-list-group id="chat-sidebar-user-group" class="chatSidebarUserGroup">
        <b-list-group-item
          v-for="conversation in this.myJson.filter(filterConversations)"
          
          :key="conversation.text"
        >
          <i :class="`fa fa-circle float-right text-success`" />
          <span class="thumb-sm float-left mr">
            <img class="rounded-circle" :src="conversation.logo_path" alt="..." />
          </span>
          <div @click="openVideo(conversation.text+'|'+conversation.date_upload+'|'+conversation.poster+'|'+conversation.src+'|'+conversation.points+'|'+conversation.percent_views+'|'+conversation.comments)">
            <h6 class="messageSender">{{conversation.text}}</h6>
            <p class="messagePreview">{{conversation.date_upload}}</p>
          </div>
        </b-list-group-item>
      </b-list-group>
     
    </div>
   
  </aside>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import $ from 'jquery';

export default {
  name: 'Chat',
  data() {
    return {

      popupText: 'bla',
      popupActive: false,

      //DATA TO SPLIT

      split_text_video: '',
      split_poster_video: '',
      split_src_video: '',
      split_views_video: '',
      split_percent_video: '',
      split_comments_video: '',
      split_points_video: '',
      
      myJson: null,
      id_company: null,

      chatMessageOpened: true,
      conversation: Object,
      searchValue: '',
    };
  },
  methods: {
      openVideo(text) {

      var split = text.split("|");

      this.split_text_video = split[0];
      this.split_poster_video = split[2];
      this.split_src_video = split[3];
      this.split_points_video = split[4];
      this.split_percent_video = split[5];
      this.split_comments_video = split[6];

      this.popupActive=true;

    },

    filterConversations(item) {
      const isFindName = item.text.toLowerCase()
        .indexOf(this.searchValue.toLowerCase()) !== -1;
      const isFindMessage = item.date_upload.toLowerCase()
        .indexOf(this.searchValue.toLowerCase()) !== -1;
      return isFindName || isFindMessage;
    },
    handleSearchInput(value) {
      Vue.set(this, 'searchValue', value);
    },
    openMessages(conversation, e) {
      Vue.set(this, 'conversation', conversation);
      Vue.set(this, 'chatMessageOpened', false);

      $(e.currentTarget).removeClass('active').find('.badge').remove();
    },
    addMessage(e) {
      if (e.key === 'Enter' && e.target.value) {
        const value = {
          text: e.target.value,
          fromMe: true,
        };

        Vue.set(this, 'conversation', Object.assign({}, this.conversation, {
          messages: [
            ...this.conversation.messages || [],
            value,
          ],
        }));

        e.target.value = '';
      }
    },
  },

 mounted(){

    this.myJson = JSON.parse(window.localStorage.getItem('json_vids'));

    console.log('JSON-TO-LIST-VIDEOS  ', this.myJson);

    this.id_company = window.localStorage.getItem('id_company');
  
  },
  created(){
    

  },

  computed: {
    ...mapState('layout', {
      chatOpen: state => state.chatOpen,
    }),
  },
};
</script>

<style src="./Chat.scss" lang="scss" />